import axios from "api/axiosConfig";

const upload = (file) => {
  let formData = new FormData();
  formData.append("file", file);

  return axios.post("/v2/filesmanager", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const ex = { upload: upload };

export default ex;
